<div class="crp1-scan-selector">
    <span class="notice">{{ 'UPLOAD.CRP1_SCAN_SELECTOR_NOTICE' | translate }}</span>
    <cw-scan-selection-tree [fileData]="fileData" (selectionChange)="setSelectedScans($event)"></cw-scan-selection-tree>
</div>